import { useState } from 'react';
import { popCalc } from './pop';

/** Calculator action; window preferences live in CUPIS Filters. */
export function CupisWorkTools({ id }: { id: string }): React.ReactElement {
  const [message, setMessage] = useState('');
  return <div className="cupis-work-tools">
    <button type="button" onClick={() => {
      setMessage('');
      popCalc(id, ok => setMessage(ok ? '' : 'Браузер не открыл калькулятор. Разрешите всплывающие окна для forq.ru и нажмите ещё раз.'));
    }}>Калькулятор в отдельное окно</button>
    {message && <span role="status">{message}</span>}
  </div>;
}
